var EmployeeDropDownView = require('../../../shared/app/views/components/employee-selector');

var MultipleGuestServiceProviderView = Backbone.Epoxy.View.extend({
  template: 'multiple-guest.multipleGuestServiceProvider',
  bindings: 'data-bind',

  events: {
    'click .guest-remove': 'removeGuest',
    'keydown .guest-remove': 'removeGuest',
  },

  initialize: function() {
    this.employeeComponent = new EmployeeDropDownView({
      model: this.model,
      boundProperty: 'provider',
      serviceProperty: 'service',
      referenceContainer: '#appointmentModal'
    });
    this.employeeComponent.matchWithServices = true;
    this.employeeComponent.filterByWaitListAvailability = bookedby.staticData.storeGroupSettings.useWaitingList;
    this.employeeComponent.showFirstAvailablePlaceholder = true;
    //this.employeeComponent.guestIndexProperty = 'index';
    //this.employeeComponent.guestIndex = this.model.get('index');

    this.render();

    this.initEvents();
  },

  updateEstimatedTime: function() {

    var guestIndex = this.model.get('index');
    var provider = this.model.get('provider');
    var newEstimatedWaitTime;

    if (provider != null) {
      var newProviderId = provider.get('id');
      newEstimatedWaitTime = bookedby.app.serviceManager.employeeByGuestWaitTimes[guestIndex][newProviderId].waitTime;
    } else {
      newEstimatedWaitTime = _.min(_.map(bookedby.app.serviceManager.employeeByGuestWaitTimes[guestIndex], function (x) { return x.waitTime; }));
    }

    var overWaitTime = newEstimatedWaitTime >= bookedby.staticData.storeGroupSettings.capWaitTimesAfter;

    if (overWaitTime) {
      var options = {
        cancelLabel: '',
        confirmLabel: 'Ok',
        showCancelLabel: false,
        message: this.model.get('overWaitTimeMessage')
      };

      bookedby.app.confirmForm.show(_.bind(function() {
        this.removeGuest();
        this.collectionView.updateOverWaitTimeShown(overWaitTime);
      }, this), function() {}, options);
    } else {
      this.model.set('estimatedWaitTime', newEstimatedWaitTime);
    }
  },

  initEvents: function() {
    //this.listenTo(this.model, 'change:provider', _.bind(this.guestProviderChanged, this));
    this.listenTo(this.model, 'change:provider', this.updateEstimatedTime);
    this.listenTo(this.model, 'waitTimesUpdated', this.updateEstimatedTime);
  },

  removeEvents: function() {
    //this.stopListening(this.model, 'change:provider', this.updateEstimatedTime);
  },

  beforeRender: function() {
    this.setView('.select-employee-area', this.employeeComponent);
  },

  afterRender: function() {
    this.applyBindings();
    this.collectionView.trigger('finishRender');
    var guestNumber = this.model.attributes.guest;
    var guestId = 'guest_name_' + guestNumber;
    var selectInputId = 'confirmationProvider_' + guestNumber;
    var guestDescribedby = 'fullNameFormatErrorMsg_' + guestNumber;
    this.$el.find('.guestName-js').attr('id', guestId);
    this.$el.find('.guestLabel-js').attr('for', guestId);
    this.$el.find('.guestName-js').attr('aria-describedby', guestDescribedby);
    this.$el.find('.guest-help-block-js').attr('id', guestDescribedby);
    this.$el.find('.guestSelectLabel-js').attr('for', selectInputId);

  },

  cleanup: function() {
    this.removeBindings();
    this.removeEvents();
  },

  removeGuest: function(e) {
      if(e === undefined || e.type !== "keydown" || (e.type === "keydown" && e.keyCode === 13)) {
          this.collectionView.removeGuest(this.model);
          //this.employeeComponent.guestIndex = this.model.get('index');
          //this.employeeComponent.render();
      }
  }
});

module.exports = MultipleGuestServiceProviderView;